import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kuaisuzhongzhuan",
  "use": "icon-kuaisuzhongzhuan-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-kuaisuzhongzhuan\"><path d=\"M13.568 7.323H10.63a.427.427 0 01-.424-.493L11.252.496c.07-.415-.45-.666-.74-.36L3.116 7.96a.426.426 0 00.315.717h2.938c.264 0 .467.236.424.493l-1.046 6.334c-.07.415.45.666.74.36l7.396-7.824a.425.425 0 00-.315-.717z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kuaisuzhongzhuan.svg
// module id = 489
// module chunks = 4